import React from 'react';
import Select from 'react-select';
import defaultTheme from '@styles/theme';

function DropdownButton({ isDisabled, ...props }) {
  const customStyles = {
    container: provided => ({
      ...provided,
      width: '100%',
      cursor: 'pointer'
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected
        ? defaultTheme.colors.primary
        : defaultTheme.colors.lightText,
      background: defaultTheme.colors.white
    }),
    menuList: () => ({
      background: defaultTheme.colors.white
    }),
    input: () => ({
      padding: 0
    }),
    control: () => ({
      padding: defaultTheme.space[3],
      borderRadius: 16,
      fontSize: 17,
      background: defaultTheme.colors.secondary,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    }),
    indicatorsContainer: () => (isDisabled ? { display: 'none' } : {}),
    dropdownIndicator: () => ({}),
    valueContainer: provided => ({
      ...provided,
      padding: 0
    }),
    singleValue: provided => {
      return { ...provided, color: defaultTheme.colors.primary };
    }
  };

  return <Select styles={customStyles} isDisabled={isDisabled} {...props} />;
}

export default DropdownButton;
